var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "请输入标题" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleFilter($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.guideTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "guideTitle", $$v)
                      },
                      expression: "listQuery.guideTitle",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleFilter },
                    },
                    [_vm._v("\n        搜索\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "filter-item",
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        type: "primary",
                        icon: "el-icon-circle-plus-outline",
                      },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("\n        新建攻略\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.strategyList,
            stripe: "",
            border: "",
            fit: "",
            "highlight-current-row": "",
            "max-height": _vm.maxHeight,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "标题", prop: "guideTitle", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "说明",
              prop: "strategyGuideDescription",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "攻略图片",
              prop: "showPictureUrl",
              align: "center",
              "min-width": "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    row.showPictureUrl === null ||
                    row.showPictureUrl === "" ||
                    row.showPictureUrl === undefined
                      ? _c("span", [_vm._v("\n          未上传图片\n        ")])
                      : _c("el-image", {
                          staticStyle: { width: "80px", height: "40px" },
                          attrs: {
                            src: _vm.resPath + row.showPictureUrl,
                            fit: "contain",
                            "preview-src-list": [
                              _vm.resPath + row.showPictureUrl,
                            ],
                            "preview-teleported": "",
                          },
                        }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "生效状态", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("el-switch", {
                      attrs: {
                        "active-value": 1,
                        "inactive-value": 0,
                        "active-color": "#13ce66",
                        "inactive-color": "#ff4949",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.handleStatusChange(
                            row.id,
                            row.effectiveStatus
                          )
                        },
                      },
                      model: {
                        value: row.effectiveStatus,
                        callback: function ($$v) {
                          _vm.$set(row, "effectiveStatus", $$v)
                        },
                        expression: "row.effectiveStatus",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "创建时间", align: "center", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.createTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "更新时间", align: "center", width: "100px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm._f("parseTime")(
                            row.updateTime,
                            "{y}-{m}-{d} {h}:{i}:{s}"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: "操作",
              align: "center",
              width: "200",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "primary",
                              icon: "el-icon-edit",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleUpdate(row)
                              },
                            },
                          },
                          [_vm._v("\n            编辑\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "mini",
                              type: "danger",
                              icon: "el-icon-delete",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(row)
                              },
                            },
                          },
                          [_vm._v("\n            删除\n          ")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c("sw-page", {
            attrs: {
              listQuery: _vm.listQuery,
              total: _vm.total,
              pos: "btmRight",
            },
            on: { retPage: _vm.retPage },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.dialog.status === "create" ? "新建攻略" : "编辑攻略",
            visible: _vm.dialog.visible,
            direction: "rtl",
            size: "40%",
            "before-close": _vm.handleDrawerClose,
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form-drawer",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "100px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "标题", prop: "guideTitle" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.formData.guideTitle,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "guideTitle", $$v)
                      },
                      expression: "formData.guideTitle",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "说明", prop: "strategyGuideDescription" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: "4" },
                    model: {
                      value: _vm.formData.strategyGuideDescription,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "strategyGuideDescription", $$v)
                      },
                      expression: "formData.strategyGuideDescription",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "展示图片", prop: "showPictureUrl" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        "on-remove": _vm.handleRemoveFile,
                        "http-request": _vm.handlePictureUpload,
                        "on-preview": _vm.handlePreview,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                        "file-list": _vm.uploadFileList,
                        action: "#",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "图片格式：jpg/png，大小≤2MB，尺寸375px*812px, 或同比例图片"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "drawer-footer" },
                [
                  _c("el-button", { on: { click: _vm.handleDrawerClose } }, [
                    _vm._v("取消"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.previewDialog.visible, width: "400px" },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewDialog, "visible", $event)
            },
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.previewDialog.url, alt: "预览图" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "上传背景图",
            visible: _vm.uploadDialog.visible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.uploadDialog, "visible", $event)
            },
            close: _vm.resetUpload,
          },
        },
        [
          _c(
            "el-upload",
            {
              staticClass: "upload-area",
              attrs: {
                drag: "",
                "auto-upload": true,
                limit: 1,
                "file-list": _vm.uploadDialog.fileList,
                "http-request": _vm.handleCustomUpload,
                "on-remove": _vm.removeFile,
                "on-change": _vm.handleFileChange,
                action: _vm.uploadAction,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _vm._v(" "),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v("拖拽或点击上传图片"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "el-upload__tip" }, [
                _vm._v("只能上传一张图片"),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }